import { combineReducers } from 'redux';
import reducerCoreLoading from './loading';
import reducerCoreUserPolicy from './policy';
var reducerCore = combineReducers({
  loading: reducerCoreLoading,
  policy: reducerCoreUserPolicy
});
export default reducerCore;